/** Partner company logins are `<exchange slug>_<name>`, with non-word characters replaced. */
export function buildCompanyLogin(slug: string, firstName: string): string {
  return `${slug}_${(firstName || '').replace(/\W/g, '_')}`;
}
